import { Avatar, Box, Card, CardContent, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';

function CustomerProfileCard({ customer }) {
  if (!customer) {
    return (
      <Card>
        <CardContent>
          <Typography>No customer data available</Typography>
        </CardContent>
      </Card>
    );
  }
  console.log('cus', customer);

  const initials =
    [customer.firstName, customer.lastName]
      .filter(Boolean)
      .map((value) => value.trim()[0])
      .join('')
      .toUpperCase() || 'NA';

  const rows = [
    {
      label: 'First Name',
      value: customer.firstName,
    },
    {
      label: 'Last Name',
      value: customer.lastName,
    },
    {
      label: 'Username',
      value: customer.username,
    },
    {
      label: 'Email',
      value: customer.email,
    },
    {
      label: 'Business Name',
      value: customer.businessName,
    },
  ];

  return (
    <Card
      sx={{
        borderRadius: '16px',
        border: '1px solid #D9DEE5',
        boxShadow: 'none',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1.5, sm: 2 },
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 2.5 },
          }}
        >
          <Avatar
            sx={{
              width: { xs: 44, sm: 52 },
              height: { xs: 44, sm: 52 },
              flexShrink: 0,
              bgcolor: '#F8EDE2',
              color: '#F58220',
              fontSize: { xs: '20px', sm: '24px' },
              fontWeight: 500,
            }}
          >
            {initials}
          </Avatar>

          <Typography
            sx={{
              fontSize: { xs: '16px !important', sm: '18px !important' },
              fontWeight: 700,
              color: '#102A43',
              minWidth: 0,
              overflowWrap: 'anywhere',
            }}
          >
            {customer.firstName} {customer.lastName}
          </Typography>
        </Box>

        <Divider />

        {/* Rows */}
        {rows.map((row, index) => (
          <Box key={row.label}>
            <Box
              sx={{
                display: 'flex',
                // Stack label over value on phones so long values (emails) have room.
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: { xs: 0.5, sm: 2 },
                px: { xs: 2, sm: 3 },
                py: { xs: 1.5, sm: 2.2 },
              }}
            >
              <Typography
                sx={{
                  fontSize: '14px !important',
                  color: '#5B7184',
                  fontWeight: 400,
                  flexShrink: 0,
                }}
              >
                {row.label}
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: '15px !important', sm: '16px !important' },
                  textAlign: { xs: 'left', sm: 'right' },
                  minWidth: 0,
                  overflowWrap: 'anywhere',
                  fontWeight: row.value ? 700 : 400,
                  color: row.value ? '#1F2933' : '#98A2B3',
                  fontStyle: row.value ? 'normal' : 'italic',
                }}
              >
                {row.value || 'N/A'}
              </Typography>
            </Box>

            {index !== rows.length - 1 && <Divider />}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}

CustomerProfileCard.propTypes = {
  customer: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    username: PropTypes.string,
    firstName: PropTypes.string,
    email: PropTypes.string,
    contact: PropTypes.string,
    businessName: PropTypes.string,
    lastName: PropTypes.string,
    status: PropTypes.string,
  }),
};

CustomerProfileCard.defaultProps = {
  customer: null,
};

export default CustomerProfileCard;
